












































































































import { Component, Mixins, Inject } from "vue-property-decorator";
import {
  IClientProviderData,
  IClientProviderMethods
} from "@/models/providers/client";
import { DataModules } from "@/store/modules/data";
import Context from "@/mixins/context";
import { AutoConsumeWallet, MultiCurrencyBalance } from "@/models/accounts";

@Component({
  components: {
    "wallet-balance": () =>
      import("@/components/app/global/wallets/walletBalance.vue")
  }
})
export default class AdminClientAccountCreditView extends Mixins(Context) {
  // Inject
  @Inject({ from: "clientProvider" })
  public readonly $clientProvider!: () => IClientProviderData;
  @Inject({ from: "clientMethods" })
  public readonly $clientMethods!: IClientProviderMethods;

  // Data
  public multiCurrencyUpdateProcessing = false;
  public multiCurrency = MultiCurrencyBalance.INHERIT;
  public originalMultiCurrency = MultiCurrencyBalance.INHERIT;
  public autoConsumeUpdateProcessing = false;
  public autoConsume = AutoConsumeWallet.INHERIT;
  public originalAutoConsume = AutoConsumeWallet.INHERIT;
  public topUpUpdateProcessing = false;
  public topUp = true;
  public originalTopUp = true;

  public async created() {
    this.multiCurrency = this.$client.account.multi_currency_balance;
    this.originalMultiCurrency = this.multiCurrency;
    this.autoConsume = this.$client.account.auto_consume_on_due_date;
    this.originalAutoConsume = this.autoConsume;
    this.topUp = this.$client.account.topup_enabled;
    this.originalTopUp = this.topUp;
  }

  private mounted() {
    this.$bus.$emit("scrollToTop");
  }

  // Computed

  public get $client() {
    return this.$clientProvider();
  }

  public get isProcessing() {
    return (
      this.multiCurrencyUpdateProcessing ||
      this.autoConsumeUpdateProcessing ||
      this.topUpUpdateProcessing
    );
  }

  public get isFormChanged() {
    return (
      this.autoConsume !== this.originalAutoConsume ||
      this.multiCurrency !== this.originalMultiCurrency ||
      this.topUp !== this.originalTopUp
    );
  }

  // Methods

  public async saveMultiCurrency() {
    if (
      this.originalMultiCurrency === this.multiCurrency ||
      this.multiCurrencyUpdateProcessing
    ) {
      return;
    }
    this.multiCurrencyUpdateProcessing = true;
    try {
      await this.$store.dispatch(
        `data/${DataModules.CLIENTS_ACCOUNTS}/update`,
        {
          accountId: this.$client.accountId,
          data: {
            multi_currency_balance: this.multiCurrency
          }
        }
      );
      this.originalMultiCurrency = this.multiCurrency;
      // @ts-ignore
      this.$refs.walletBalance.getBalance();
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
    this.multiCurrencyUpdateProcessing = false;
  }

  public async saveAutoConsume() {
    if (
      this.autoConsume === this.originalAutoConsume ||
      this.autoConsumeUpdateProcessing
    ) {
      return;
    }
    this.autoConsumeUpdateProcessing = true;
    try {
      await this.$store.dispatch(
        `data/${DataModules.CLIENTS_ACCOUNTS}/update`,
        {
          accountId: this.$client.accountId,
          data: {
            auto_consume_on_due_date: this.autoConsume
          }
        }
      );
      this.originalAutoConsume = this.autoConsume;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
    this.autoConsumeUpdateProcessing = false;
  }

  public async saveTopUp() {
    if (this.topUp === this.originalTopUp || this.topUpUpdateProcessing) {
      return;
    }
    this.topUpUpdateProcessing = true;
    try {
      await this.$store.dispatch(
        `data/${DataModules.CLIENTS_ACCOUNTS}/update`,
        {
          accountId: this.$client.accountId,
          data: {
            topup_enabled: this.topUp
          }
        }
      );
      this.originalTopUp = this.topUp;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
    this.topUpUpdateProcessing = false;
  }

  public async save() {
    await Promise.all([
      this.saveAutoConsume(),
      this.saveMultiCurrency(),
      this.saveTopUp()
    ]);
    this.$clientMethods.reloadData();
    this.$buefy.toast.open({
      message: this.$t("_.object_successfully_updated", {
        object: this.$t("_.account")
      }) as string
    });
  }

  public revertToInitialState() {
    this.autoConsume = this.originalAutoConsume;
    this.multiCurrency = this.originalMultiCurrency;
  }

  public openTransactionsModal() {
    this.$store.dispatch(`data/${DataModules.WALLETS}/openTransactionsModal`, {
      props: { accountId: this.$client.accountId }
    });
  }

  public async openTopUpModal() {
    const topUpModal = await this.$store.dispatch(
      `data/${DataModules.WALLETS}/openTopUpModal`,
      {
        props: {
          client: this.$client.client
        },
        events: {
          success: () => {
            // @ts-ignore
            this.$refs.walletBalance.getBalance();
            topUpModal.close();
          }
        }
      }
    );
  }
}
